let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8Yg3F")).then(() => parcelRequire('g02gC'));